import { IUser } from "@logex/framework/lg-application";
import { Language } from "@mrdm-self-service-frontend/shared/assets";

export class SharedAppUser implements IUser {
    id = 0;
    name = "";
    roles: Record<string, boolean>;
    title = "";
    userid = "";
    ziekenhuiscode = 0;
    ziekenhuisnaam = "";
    impersonator?: string | undefined;
    impersonatorName?: string | undefined;
    isInternal = false;

    // authorization api /user/profile
    locale?: Language;
    SSPLegalConsentGranted?: boolean;
    email: string = "";

    initialized: boolean = false;

    constructor() {
        this.roles = {};
    }

    public hasPermission(role: string): boolean {
        if (role === "switch_language") {
            // hardcode to show language switch
            return true;
        }
        return this.roles[role] || false;
    }
}
